<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

let xLabel = ["小黄姜", "大黄姜", "仔姜", "老姜", "姜种"];
let goToSchool = ["1.4", "0", "1.9", "0", "0"];
let goOutSchool = ["0.999", "0.999", "0.999", "0.999", "1"];
let goOutSchool1 = ["0", "0.5", "0", "0.9", "0"];

const option = {
  // backgroundColor: "#0e1c47",
  color: ["#EF4C50", "#FFD24A", "#0AB390", "#4AA2FF"],
  tooltip: {
    trigger: "axis",
    borderWidth: 2,
    show: false,
    padding: [5, 10],
    formatter: (params) => {
      // console.log('params',params)
      let str = `${params[0].name}月<br/>`;
      //seriesName color value
      for (let i = 0; i < params.length; i++) {
        str =
          str +
          `<span style='display:inline-block;margin-right:5px;
                border-radius:10px;width:9px;height:9px;background-color:${params[i].color}'></span>
                ${params[i].seriesName}：<i style='float:right;color:#4AEFED ' >${params[i].value}件</i><br/>`;
      }
      return str;
    },
  },
  legend: {
    align: "left",
    right: "10%",
    top: "8%",
    type: "plain",
    textStyle: {
      color: "#fff",
      fontSize: 26,
    },
    icon: "rect",
    itemGap: 35,
    itemWidth: 25,
  },
  grid: {
    top: "18%",
    left: "10%",
    right: "10%",
    bottom: "15%",
    // containLabel: true
  },
  title: {
    text: "需求关系比=需求热度/供应热度",
    // subtext: "13000吨",

    textStyle: {
      color: "#f2f2f2",
      fontSize: 24,
    },

    x: "5%",
    y: "5%",
  },
  xAxis: [
    {
      type: "category",
      name: "",
      nameGap: 10,
      boundaryGap: false,
      nameTextStyle: {
        // ---坐标轴名称样式
        color: "#E2E8EDE8",
        fontSize: 26,
      },
      axisLabel: {
        show: true,
        interval: 0, //横轴信息全部显示
        // rotate:-30,//-30度角倾斜显示
        textStyle: {
          color: "#FFFFFF", // 更改坐标轴文字颜色
          fontSize: 26, // 更改坐标轴文字大小
          padding: [20, 20, 0, 0],
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: [5, 10],
          dashOffset: 10,
          color: "#1282C8",
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#379E98AB",
        },
      },
      axisTick: {
        show: false,
      },
      data: xLabel,
    },
  ],
  yAxis: [
    {
      splitLine: {
        show: false,
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#FFFFFF", // 更改坐标轴文字颜色
          fontSize: 26, // 更改坐标轴文字大小
          padding: [0, 20, 0, 0],
        },
        formatter: function (value) {
          // 当值为 0 时不显示标签
          return value == 0 ? "" : value;
        },
      },
    },
  ],
  series: [
    {
      name: "供不应求",
      type: "line",
      // symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
      showAllSymbol: true,
      // symbolSize: 3,
      symbol: function (value) {
        return value == 0 ? " " : "circle";
      },
      symbolSize: function (value) {
        return value == 0 ? 0 : 8; // 当值为0时，符号大小设为0，即不显示
      },
      smooth: true,
      label: {
        show: true,
        position: "top", // 或者使用 'bottom', 'left', 'right' 来调整数值显示的位置

        formatter: function (params) {
          // 明确检查值是否为0，仅当非0时返回数值，否则返回空字符串
          return params.value == 0 ? "" : params.value;
        },
        fontSize: 26, // 可选，调整数值标签的字体大小
        color: "#EF4C50", // 可选，数值标签的颜色
      },
      lineStyle: {
        normal: {
          width: 0,
          type: "dashed", //将折线改为虚线
        },
        borderColor: "rgba(0,0,0,.4)",
      },
      itemStyle: {
        borderColor: "#EF4C50",
        borderWidth: 2,
      },
      tooltip: {
        show: true,
      },
      data: goToSchool,
    },
    {
      name: "供需平衡",
      type: "line",
      showAllSymbol: true,
      // symbol: "circle",
      // symbolSize: 2,
      symbol: function (value) {
        return value == 0.999 ? " " : "circle";
      },
      symbolSize: function (value) {
        return value == 0.999 ? 0 : 8; // 当值为0时，符号大小设为0，即不显示
      },

      smooth: true,
      label: {
        show: true,
        position: "bottom", // 或者使用 'bottom', 'left', 'right' 来调整数值显示的位置
        // padding: [0, 20, 10, 10],
        formatter: function (params) {
          // 明确检查值是否为0，仅当非0时返回数值，否则返回空字符串
          return params.value == 0.999 ? "" : params.value;
        },
        fontSize: 26, // 可选，调整数值标签的字体大小
        color: "#FFD24A", // 可选，数值标签的颜色
      },
      lineStyle: {
        normal: {
          width: 1,
          type: "dashed", //将折线改为虚线
        },
        borderColor: "rgba(0,0,0,.4)",
      },
      itemStyle: {
        borderColor: "#FFD24A",
        borderWidth: 2,
      },
      tooltip: {
        show: true,
      },
      data: goOutSchool,
    },
    {
      name: "供大于求",
      type: "line",

      showAllSymbol: true,

      symbol: function (params) {
        return params == 0 ? "none" : "circle";
      },
      symbolSize: function (params) {
        return params == 0 ? 0 : 8; // 当值为0时，符号大小设为0，即不显示
      },

      smooth: true,
      label: {
        show: true,
        position: "bottom", // 或者使用 'bottom', 'left', 'right' 来调整数值显示的位置
        // padding: [0, 20, 10, 10],
        formatter: function (params) {
          // 明确检查值是否为0，仅当非0时返回数值，否则返回空字符串
          return params.value == 0 ? "" : params.value;
        },
        fontSize: 26, // 可选，调整数值标签的字体大小
        color: "#0AB390", // 可选，数值标签的颜色
      },
      lineStyle: {
        normal: {
          width: 0,
          type: "dashed", //将折线改为虚线
        },
        borderColor: "rgba(0,0,0,.4)",
      },
      itemStyle: {
        borderColor: "#0AB390",
        borderWidth: 2,
      },
      tooltip: {
        show: true,
      },
      data: goOutSchool1,
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
